import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appTextareaResize]',
    standalone: false
})

export class TextareaResizeDirective {
  constructor(public element: ElementRef) { }

  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    const inputTextarea = event.target;
    this.init(inputTextarea);
  }
  ngOnInit(textArea: HTMLTextAreaElement): void {
    const inputTextArea = this.element.nativeElement
    this.init(inputTextArea);
  }

  init(textArea) { 
    // textArea['style'].overflow = 'hidden';
    if (textArea['scrollHeight'] != undefined && textArea['scrollHeight'] != 0)
    textArea['style']['min-height'] = 60 + 'px';
    textArea['style'].height = textArea['scrollHeight'] + 'px';
     

  }
}
